/**
 *
 * Unsubscribe/UnsubscribeContact
 *
 */

import React, { useState, useEffect } from 'react'

// NPM Libraries
import axios from 'axios'

// Components
import Checkbox from 'components/Checkbox'
import { Contact } from 'globalVars'
import { addDays } from 'date-fns'

function UnsubscribeContact({
	settings,
	options: automation_topics,
	// recipient_id: contact_id,
	company_name,
	block_email,
	email_id,
	block_emails_until,
}) {
	const {
		COMMUNICATION_ALLOWED,
		COMMUNICATION_BLOCKED,
		COMMUNICATION_UNSUBSCRIBED_BY_CONTACT,
		COMMUNICATION_ALLOWED_BY_CONTACT,
	} = Contact

	const [contact_topics, setContactTopics] = useState(settings) // object
	const [block_email_state, setBlockEmail] = useState(block_email) // integer
	const [submitting, setSubmitting] = useState(false)
	const [message, setMessage] = useState()
	const [unsubscribed_until, setUnsubscribedUntil] = useState()

	useEffect(() => {
		// set each allowed value as COMMUNICATION_ALLOWED_BY_CONTACT
		const new_settings = {}
		automation_topics.forEach((topic) => {
			// console.log(topic.value, settings[topic.value], COMMUNICATION_ALLOWED, settings[topic.value] == COMMUNICATION_ALLOWED)
			if (settings[topic.value] === COMMUNICATION_ALLOWED) {
				new_settings[topic.value] = COMMUNICATION_ALLOWED_BY_CONTACT
			} else {
				new_settings[topic.value] = settings[topic.value]
			}
		})
		setContactTopics(new_settings)

		// set unsubscribed_until
		if (block_emails_until) {
			setUnsubscribedUntil(new Date(block_emails_until))
			setMessage(`You are unsubscribed until ${block_emails_until}.`)
		}
	}, [settings])

	const topicIsAllowed = (topic) =>
		block_email_state !== COMMUNICATION_UNSUBSCRIBED_BY_CONTACT &&
		contact_topics[topic] === COMMUNICATION_ALLOWED_BY_CONTACT

	const handleSubmit = () => {
		setSubmitting(true)
		axios({
			method: 'PUT',
			url: `${process.env.API_URL}/api/v1/emails/settings/${email_id}/update_contact`,
			data: {
				automation_topics: JSON.stringify(contact_topics),
				block_email: block_email_state,
				block_emails_until: unsubscribed_until,
			},
		})
			.then((response) => {
				setSubmitting(false)
				if (response.status === 200 && response.data.updated) {
					if (response.data.contact?.block_emails_until) {
						setMessage(`You are unsubscribed until ${response.data.contact.block_emails_until}.`)
					} else {
						setMessage('Thank you, your settings have been saved.')
					}
				}
			})
			.catch((error) => {
				setSubmitting(false)
				throw error
			})
	}

	return (
		<div className="m-4 ml-sm-5">
			<h3>{company_name} Email Settings</h3>

			<p>Would you like to receive information on any of the following topics?</p>
			<ul className="list-unstyled">
				{automation_topics.map((topic) => (
					<li key={topic.value}>
						<Checkbox
							label={topic.name}
							checked={topicIsAllowed(topic.value)}
							onChange={(checked) => {
								setMessage('')
								const state = { ...contact_topics }

								if (block_email_state === COMMUNICATION_UNSUBSCRIBED_BY_CONTACT) {
									Object.keys(state).forEach((key) => {
										state[key] = COMMUNICATION_UNSUBSCRIBED_BY_CONTACT

										return false
									})

									state[topic.value] = COMMUNICATION_ALLOWED_BY_CONTACT
									setBlockEmail(COMMUNICATION_ALLOWED)
								} else {
									state[topic.value] = checked
										? COMMUNICATION_ALLOWED_BY_CONTACT
										: COMMUNICATION_UNSUBSCRIBED_BY_CONTACT
								}
								setContactTopics(state)
							}}
						/>
					</li>
				))}
			</ul>
			<div>
				<Checkbox
					label={`None - unsubscribe from all emails from ${company_name}.`}
					checked={
						block_email_state === COMMUNICATION_BLOCKED ||
						block_email_state === COMMUNICATION_UNSUBSCRIBED_BY_CONTACT
					}
					onChange={(checked) => {
						setMessage('')
						if (checked) {
							setBlockEmail(COMMUNICATION_UNSUBSCRIBED_BY_CONTACT)
							setUnsubscribedUntil(null)
						} else {
							setBlockEmail(COMMUNICATION_ALLOWED)
						}
					}}
				/>
			</div>
			<div>
				<Checkbox
					label="Unsubscribe from all emails for 30 days."
					checked={Boolean(unsubscribed_until)}
					onChange={(checked) => {
						setMessage('')
						if (checked) {
							setUnsubscribedUntil(addDays(new Date(), 30))
							setBlockEmail(COMMUNICATION_ALLOWED)
						} else {
							setUnsubscribedUntil(null)
						}
					}}
				/>
			</div>

			<div>
				<button
					type="button"
					className="btn btn-primary rounded my-4"
					disabled={submitting}
					onClick={handleSubmit}
				>
					Submit
				</button>
				<div>
					<strong>{message}</strong>
				</div>
			</div>
		</div>
	)
}

UnsubscribeContact.propTypes = {}

export default UnsubscribeContact
